"use client";

import React from 'react';
import Image from 'next/image';

const Hero = () => {
        
    return (
        <div>

    <section className="relative py-12 sm:py-32 lg:pb-40">
        <div className="absolute bottom-0 right-0 overflow-hidden">
            <img className="w-full h-auto origin-bottom-right transform scale-150 lg:w-auto lg:mx-auto lg:object-cover lg:scale-75" src="/images/background-pattern.png" alt="" />
        </div>

        <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-y-4 lg:items-center lg:grid-cols-2 xl:grid-cols-2">
                <div className="text-center xl:col-span-1 lg:text-left md:px-16 lg:px-0 xl:pr-20">
                    <h1 className="text-xl font-bold leading-tight text-gray-900 sm:text-5xl sm:leading-tight lg:text-5xl lg:leading-tight font-pj">Stop Paying per Task.</h1>
                    <p className="mt-2 text-lg text-gray-600 sm:mt-6 font-inter">Zapier bills every run - we don't. <br />We custom-build your flows so you can run them endlessly. <br />No limits, no extra fees.</p>

                    <div className="pt-8 flex flex-col sm:inline-flex sm:flex-row sm:space-x-4 items-center w-full sm:w-auto">
                        <div className="flex flex-col sm:flex-row items-center gap-10">
                            <div
                                className="relative group mb-4 sm:mb-0"
                            >
                                <div
                                    className="absolute duration-1000 rotate-180 transitional-all opacity-70 -inset-px rounded-xl blur-lg filter group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200"
                                    style={{ background: "linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)" }}
                                ></div>
                                <a
                                    href="#"
                                    title=""
                                    className="relative inline-flex items-center justify-center py-3.5 text-base font-bold text-white transition-all duration-200 bg-gray-900 border border-transparent px-9 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 font-pj hover:bg-opacity-90 rounded-xl"
                                    role="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const ctaSection = document.querySelector('section[id="cta"]');
                                        ctaSection?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                >
                                    Get Started
                                </a>
                            </div>
                           
                        </div>
                    </div>
                        
                    <div className="mt-8 sm:mt-16">
                        <div className="flex items-center justify-center lg:justify-start">
                            <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                />
                            </svg>
                            <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                />
                            </svg>
                            <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                />
                            </svg>
                            <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                />
                            </svg>
                            <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                />
                            </svg>
                        </div>

                        <blockquote className="mt-6">
                            <p className="text-lg font-bold text-gray-900 font-pj">
                                "We slashed our Zapier bill by 80%"
                            </p>
                            <p className="mt-3 text-base leading-7 text-gray-600 font-inter">
                                Zapier was billing us for 15 000 tasks per month for our HubSpot integration.
                                Now the webhooks fire unlimited times - huge savings!"
                            
                            </p>
                            </blockquote>

                            <div className="flex items-center justify-center mt-3 lg:justify-start">
                            
                            <p className="ml-2 text-base font-bold text-gray-900 font-pj">
                                Denny J, Growth Ops Lead
                            </p>
                            </div>
                    </div>
                </div>

                <div className="xl:col-span-1 hidden sm:block">
                <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">

                <div className="relative max-w-md mx-auto mt-8 sm:mt-16">
                      <div className="relative mt-8 sm:mt-12 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mt-0">
                        <div className="absolute inset-16">
                            <div className="w-full h-full mx-auto rotate-180 opacity-30 rounded-3xl blur-lg filter" style={{ background: "linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)" }}></div>
                        </div>

                        <div className="relative space-y-5">
                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
                                <div className="flex items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/google-sheets.png" alt="Vertex" width={50} height={50} sizes="50px" />
                                    <p className="text-gray-900 font-pj">Google Sheets</p>
                                </div>

                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/gmail.png" alt="Gmail" width={50} height={50} sizes="50px" />
                                    <p className="text-gray-900 font-pj">Gmail</p>
                                </div>

                                <div className="flex items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/slack.png" alt="Slack" width={50} height={50} sizes="50px" />
                                    <p className="text-gray-900 font-pj">Slack</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 xl:translate-x-6">
                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/hubspot.png" alt="HubSpot" width={40} height={40} sizes="40px" />
                                    <p className="text-gray-900 font-pj">HubSpot</p>
                                </div>

                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/facebook.png" alt="Facebook" width={40} height={40} sizes="40px" />
                                    <p className="text-gray-900 font-pj">Facebook</p>
                                </div>

                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/mailchimp.png" alt="Mailchimp" width={40} height={40} sizes="40px" />
                                    <p className="text-gray-900 font-pj">Mailchimp</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 xl:translate-x-12">
                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/trello.png" alt="Trello" width={40} height={40} sizes="40px" />
                                    <p className="text-gray-900 font-pj">Trello</p>
                                </div>

                                <div className="flex gap-2 items-center justify-center px-6 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    <Image src="/images/shopify.png" alt="Shopify" width={40} height={40} sizes="40px" />
                                    <p className="text-gray-900 font-pj">Shopify</p>
                                </div>

                                <div className="flex items-center justify-center px-4 py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg w-44 md:w-full">
                                    
                                    <p className="text-gray-900 font-pj">1000+ Apps</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </div>
            </div>
        </div>
        
    </section>

</div>

    )
}
export default Hero; 